import React from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { ReduxUpdater } from "../../redux/ReduxUpdater";
import { Column, DataTable } from "../components/elements/Forms/DataTable";
import { ApiCalls, IReceiptHistoryData, IReceiptsHistoryResponseData } from "../../ApiCalls";
import { useQuery } from "@tanstack/react-query";
import { GlobalVariables } from "../../GlobalVariables";
import { formatReceiptDate } from "../components/elements/Forms/DateTimeInput";
import JsonViewer from "./components/JsonViewer";
import { X } from "lucide-react";

const ReceiptHistoryDialog = () => {
    const currentActiveDialogState = useSelector(activeDialogState);
    
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [currentPageSize, setCurrentPageSize] = React.useState(10);
    const [historyResponseData, setHistoryResponseData] = React.useState<IReceiptsHistoryResponseData | null>(null);
    // const [usersData, setUsersData] = React.useState<ICrewData[]>([]);

    React.useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                ReduxUpdater.currentDialog = null;
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    React.useEffect(() => {
        setOpen(currentActiveDialogState === 'receiptHistory');
    }, [currentActiveDialogState]);

     
    // // const { toast } = useToast();
    // const queryClient = useQueryClient();

    // // accountingCategories, coOwners
    // React.useEffect(() => {
    //     if (historyResponseData?.items.length === 0) {
    //         setUsersData([]);
    //         return;
    //     }
    //     ApiCalls.crew .then(d => { GlobalVariables.accountingCategories = [...d] }).catch(err => console.error(err));
    // }, [historyResponseData]);

    // Fetch receipts
    const { data: history = [], isLoading, error, refetch } = useQuery({
        queryKey: ['receipt_hystory', GlobalVariables.dialogConfig.id],
        queryFn: async () => {
            if (!GlobalVariables.dialogConfig.id) {
                return [];
            }

            const res = await ApiCalls.receiptHistory(parseInt(GlobalVariables.dialogConfig.id), currentPage, currentPageSize);
            setHistoryResponseData(res);
            return res.items;
        }
    });

    React.useEffect(() => {
        refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, currentPageSize]);

    const COLUMNS: Column<IReceiptHistoryData>[] = [
        {
            key: "created_at",
            label: "Timestamp",
            width: "1fr",
            align: "center",
            sortable: false,
            render: (_, row) => (<>{formatReceiptDate(new Date(row.created_at))}</>),
        },
        {
            key: "changed_by_user_id",
            label: "User",
            width: "1fr",
            align: "center",
            sortable: false,
            // render: (_, row) => (<>{formatReimbursementDate(new Date(row.transaction_date ?? row.created_at))}</>),
        },
        {
            key: "event_type",
            label: "Type",
            width: "1.5fr",
            align: "center",
            sortable: false,
            // render: (_, row) => (<>{formatReimbursementDate(new Date(row.transaction_date ?? row.created_at))}</>),
        },
        {
            key: "source",
            label: "Source",
            width: "1fr",
            align: "center",
            sortable: false,
            // className: "font-medium text-gray-900 dark:text-gray-100",
            // render: (_, row) => (<>{Number(row.amount).toFixed(2)} <span className="text-gray-500 text-xs ml-0.5">{row.currency}</span></>),
        },
        {
            key: "changes",
            label: <><div className="w-full"></div>Changes<div className="w-full"></div><button className="bg-red-600 rounded-xl p-0.5" onClick={() => ReduxUpdater.currentDialog = null}><X height={20} width={20} /></button></>,
            width: "8fr",
            align: "center",
            sortable: false,
            render: (_, row) => <JsonViewer title="" data={
                Object.entries(row.changes).reduce((acc, [key, value]) => {
                    // const newKey = keyMap[key] || key; // Fallback to original key if not in map
                    acc[key] = `${(value as any).old} => ${(value as any).new}`;
                    return acc;
                }, {})
            } />,
        },
    ];

    return (
        <div>
            {/* Overlay */}
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="w-[1262px] max-w-[100vw] h-[-webkit-fill-available] flex justify-center items-center overflow-hidden p-4">
                        <DataTable<IReceiptHistoryData>
                            columns={COLUMNS}
                            data={history}
                            pagination={{ page: currentPage, pageSize: currentPageSize, total: historyResponseData?.total ?? -1 }}
                            loading={isLoading}
                            onPageChange={setCurrentPage}
                            onPageSizeChange={setCurrentPageSize}
                            className='h-full w-full mb-4 min-h-[400px]'
                            // rowCss={'h-50 min-h-50'}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default ReceiptHistoryDialog;
